module.exports = __webpack_public_path__ + "img/home_banner5.8f966dbb.jpg";